import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './machineTypeModal.css';
import CreateEdit from '../PolicyProduct/RiskFactor/MachineType/CreateEdit';

function MachineTypeCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          setNewValue={setNewValue}
          closeCreateEditForm={handleClose}
          machineTypeEditDatas={null}
          editStatus={false}
          productId={productId}
        />
      </DialogContent>
    </Dialog>
  );
}

export default MachineTypeCreateModal;
